/*eslint-disable*/
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Container
} from "@mui/material";
import info from "../../app-info";

function Navbar(props) {
  const { t } = useTranslation();

  const handleLoginClick = () => {
    if (props.setForgot) {
      props.setForgot(false); // Reset dello stato nel componente Login.js
    }
  };

  return (
    <AppBar 
      position="absolute" 
      elevation={0} 
      sx={{ backgroundColor: "transparent", top: 0, zIndex: 50 }}
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ justifyContent: "space-between" }}>
          {/* Brand / Logo sempre a sinistra */}
          <Typography
            variant="h6"
            component={Link}
            to="/"
            sx={{
              color: "white",
              textDecoration: "none",
              //fontWeight: "bold",
              textTransform: "uppercase",
              fontSize: "0.875rem",
            }}
          >
            {info.title}
          </Typography>

          {/* Bottone Login sempre a destra (senza menu mobile) */}
          <Button
            component={Link}
            to="/auth/login"
            onClick={handleLoginClick}
            sx={{
              color: "white",
              //fontWeight: "bold",
              fontSize: "0.875rem",
              textTransform: "uppercase",
              "&:hover": {
                color: "#cbd5e0",
              },
            }}
          >
            Login
          </Button>
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default Navbar;